exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/home/rob/Staxi/client/src/app/serve-street/street/street.component.sass
// module id = ../../../../../src/app/serve-street/street/street.component.sass
// module chunks = main